import ColorUtil from "@/utils/color"
import { colors } from "@/styles/colors"
import { createTheme } from "@mui/material"

export const ZIndex = {
	base: 10,
	dropdown: 15,
	menu: 20,
	overlay: 30,
	modal: 40
} as const

const defaultTheme = createTheme()

const theme = createTheme({
	palette: {
		background: {
			default: colors.gray[50],
			paper: colors.gray[0]
		},
		primary: {
			main: colors.getPrimaryColor()
		},
		secondary: {
			main: colors.green[600],
			contrastText: colors.gray[0]
		},
		info: {
			main: colors.blue[300]
		},
		warning: {
			main: colors.yellow[400]
		},
		success: {
			main: colors.green[600]
		},
		text: {
			primary: colors.gray[700]
		}
	},

	typography: {
		fontFamily: "IBM Plex Sans, sans-serif",
		htmlFontSize: 16,

		h1: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "15px",
			lineHeight: "20px",
			color: colors.gray[200]
		},

		h2: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "14px",
			lineHeight: "19px",
			color: colors.gray[400]
		},

		h3: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "26px",
			lineHeight: "48px",
			color: colors.gray[900]
		},

		h4: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "16px",
			lineHeight: "24px",
			color: colors.gray[700]
		},

		h5: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 700,
			fontSize: "12px",
			lineHeight: "16px"
		},

		body1: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "16px",
			lineHeight: "24px",
			color: colors.gray[700]
		},

		overline: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "14px",
			lineHeight: "24px",
			textTransform: "none",
			color: colors.gray[700]
		},

		caption: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "12px",
			lineHeight: "16px",
			color: colors.gray[400]
		},

		button: {
			fontFamily: "IBM Plex Sans",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "1rem",
			lineHeight: "125%"
		}
	},

	components: {
		MuiLink: {
			styleOverrides: {
				root: {
					color: colors.blue[700]
				}
			}
		},
		MuiFab: {
			styleOverrides: {
				root: {
					boxShadow: "0px 2px 4px rgba(33, 36, 41, 0.08)",
					...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
				}
			}
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontFamily: "IBM Plex Sans",
					fontSize: "14px",
					fontWeight: 400,
					lineHeight: "24px",
					color: colors.gray[700]
				}
			}
		},
		MuiButton: {
			styleOverrides: {
				root: {
					padding: 16,
					textTransform: "none",
					fontFamily: "IBM Plex Sans"
				},
				outlinedPrimary: {
					borderColor: colors.purple[200]
				}
			}
		},

		MuiFormLabel: {
			styleOverrides: {
				root: {
					lineHeight: "24px",
					fontSize: "15px",
					fontFamily: "IBM Plex Sans"
				}
			}
		},

		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: 12,
					fontFamily: "IBM Plex Sans"
				}
			}
		},

		MuiDialog: {
			styleOverrides: {
				paper: {
					borderRadius: "4px",
					padding: "16px"
				}
			}
		}
	},

	shadows: Object.values({
		...defaultTheme.shadows,
		0: "0px 0px 0px rgba(0, 0, 0, 0)",
		1: "0px 2px 4px rgba(33, 36, 41, 0.08)"
		// eslint-disable-next-line
	}) as any
})

export default theme
